import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "settings/Api";
import { fetchTradingFloors } from "utils/fetchTradingFloors";

const EditSite = () => {
  const [site, setSite] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    fetchTradingFloors(getSite);
  }, []);

  const getSite = (sites) => {
    setSite(sites.find((item) => item?.id === parseInt(id)));
  };

  console.log(site);

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;

    setSite({
      ...site,
      [name]: value,
    });
  };

  const navigate = useNavigate();

  const postData = () => {
    const token = JSON.parse(localStorage.getItem("authTokens")).data
      .accessToken;

    api("/api/sout/handbooks/tradingfloors", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(site),
    }).then((res) => {
      if (res.status === 200 || res.ok) {
        alert("Площадка изменена!");
        navigate("/ListOfSites");
      } else if (res.status === 500 || !res.ok) {
        alert("Ошибка. Площадка не создана!");
      }
    });
  };

  return (
    <main className="workspace">
      <Sidebar />
      <div className="workspace__content">
        <section className="workspace__wrapper">
          <h3 className="workspace__title workspace__page-title">
            Редактировать площадку
          </h3>
          <form style={{ width: 400 }}>
            <p className="workspace__input-title">Наименование:</p>
            <input
              className="input"
              type="text"
              name="name"
              value={site?.name}
              onChange={inputChangeHandler}
            />
            <p className="workspace__input-title">Описание</p>
            <input
              className="input"
              type="text"
              value={site?.description}
              name="description"
              onChange={inputChangeHandler}
            />
            <p className="workspace__input-title">Ссылка</p>
            <input
              className="input"
              type="text"
              value={site?.link}
              name="link"
              onChange={inputChangeHandler}
            />

            <div style={{ display: "flex" }}>
              <input
                type="button"
                disabled={site?.name?.length <= 0}
                onClick={postData}
                className="button staff__create-staff-button"
                value="Добавить"
              />
              <input
                type="button"
                style={{ marginLeft: 20 }}
                onClick={() => {
                  navigate(-1);
                }}
                className="button staff__create-staff-button"
                value="Отмена"
              />
            </div>
          </form>
        </section>
      </div>
    </main>
  );
};
export default EditSite;
